/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { FloorParentFragmentDoc } from "../../floors/graphql/fragments.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type RoomRecursiveParentFragment = {
  __typename: "Room"
  parent?:
    | {
        __typename: "Floor"
        id: string
        label?: string | null
        parent?: { __typename: "Project"; id: string; title: string } | null
      }
    | { __typename: "Project"; id: string; title: string }
    | null
}

export const RoomRecursiveParentFragmentDoc = gql`
  fragment RoomRecursiveParent on Room {
    parent {
      ... on Project {
        id
        title
      }
      ... on Floor {
        id
        label
        ...FloorParent
      }
    }
  }
  ${FloorParentFragmentDoc}
`
